import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const FORCED_RESET_PATH = "/password-reset-required";

// Paths the user is still allowed to reach while their password reset is
// pending: the reset page itself, the auth pages (so they can sign out and
// sign back in), and the reset-via-email flow.
const ALLOWED_WHILE_LOCKED = new Set<string>([
  FORCED_RESET_PATH,
  "/login",
  "/forgot-password",
  "/reset-password",
  "/unsubscribe",
]);

/**
 * Wraps the app's routes. When the signed-in user's password was flagged by
 * HIBP at login, redirects any navigation away from the reset page until the
 * user picks a new password.
 */
const ForcePasswordResetGate = ({ children }: { children: ReactNode }) => {
  const { mustResetPassword, user, loading } = useAuth();
  const location = useLocation();

  if (loading || !user || !mustResetPassword) {
    return <>{children}</>;
  }

  if (ALLOWED_WHILE_LOCKED.has(location.pathname)) {
    return <>{children}</>;
  }

  return <Navigate to={FORCED_RESET_PATH} replace state={{ from: location.pathname }} />;
};

export default ForcePasswordResetGate;
